import Highcharts from "Static/js/highstock";
import { KILOBYTE, MEGABYTE } from "constant/app";
import each from "lodash/each";
import PropTypes from "prop-types";
import React from "react";
import { utcToLocal } from "util/time";

const DATA_SENT_LABEL = "Sent (KB)";
const DATA_RECEIVED_LABEL = "Received (MB)";

class NetworkChart extends React.PureComponent {
  static get propTypes() {
    return {
      data: PropTypes.array.isRequired,
    };
  }

  constructor(props) {
    super(props);

    this.chartElem = null;
    this.highchart = null;

    this.destroy = this.destroy.bind(this);
  }

  componentDidUpdate() {
    this._renderChart(this.props);
  }

  componentDidMount() {
    this._renderChart(this.props);
  }

  componentWillUnmount() {
    this.destroy();
  }

  destroy() {
    if (this.highchart) {
      this.highchart.destroy();
    }
  }

  _getData(props) {
    const seriesArr = [];
    const sentData = [];
    const recvData = [];

    props.data.forEach((p) => {
      const [ts, networkSend, networkRecv] = p;

      // Sent data is displayed in KB
      sentData.push([ts, networkSend / KILOBYTE]);

      // Recv data is displayed in MB
      recvData.push([ts, networkRecv / MEGABYTE]);
    });

    seriesArr.push(
      {
        name: DATA_SENT_LABEL,
        data: sentData,
      },
      {
        name: DATA_RECEIVED_LABEL,
        data: recvData,
      },
    );

    return seriesArr;
  }

  _renderChart(props) {
    const noData = props.data.length === 0;
    if (noData) {
      return;
    }

    const { chartElem } = this;
    const opts = {
      chart: {
        renderTo: chartElem,
        type: "line",
      },
      title: "Network Usage",
      xAxis: {
        type: "datetime",
        labels: {
          enabled: true,
        },
      },
      tooltip: {
        formatter: function () {
          // Do not make this an arrow function.
          let t = utcToLocal(this.points[0].x) + `<br>`;

          each(this.points, (p) => {
            t += `${p.series.name}: `;
            if (p.series.name === DATA_SENT_LABEL) {
              t += `<b>${p.y.toFixed(2)} KB</b><br>`;
            } else {
              t += `<b>${p.y.toFixed(2)} MB</b><br>`;
            }
          });

          return t;
        },
        shared: true,
      },
      yAxis: {
        title: "Network Usage",
        type: "category",
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        startOnTick: false,
        showFirstLabel: true,
        showLastLabel: true,
      },
      series: this._getData(props),
      plotOptions: {
        series: {
          lineWidth: 1,
          marker: {
            enabled: false,
          },
        },
      },
      credits: {
        enabled: false,
      },
    };

    this.destroy();

    this.highchart = new Highcharts.Chart(opts);
  }

  render() {
    const noData = this.props.data.length === 0;

    return (
      <div
        className="chart network-chart"
        ref={(c) => {
          this.chartElem = c;
        }}
      >
        {noData && <div>No data for chart.</div>}
      </div>
    );
  }
}

export { NetworkChart };
